/* eslint-disable max-lines */
import React, {useMemo} from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {tableHeaderWithProps} from '../columns/columns';
import {FloatingInventoryFilter} from './TableFilters';
import {formFloatInvErrors} from '../../../constants/initialErrors';
import {formFloatInvData} from '../../../constants/initialFormData';
import {resetFiltersValue} from '../../../constants/resetValues';

const FloatInventoryTable = ({
  cleanCurrentLineFloating,
  dataTable,
  deleteFloatingInventory,
  dealerId,
  exonerationsList,
  isUserTde,
  putFloatingInventory,
  setFilteredRowsData,
  updateTable,
  setShowModalOrderInfo,
  setCurrentFloatingLine,
  setCurrentLine,
  setCurrentLineError,
  setCurrentFloatingOrderClient,
  currentFlUserGroup,
  resetAllFilters,
  setResetAllFilters,
  filters,
}) => {
  const columnsTable = tableHeaderWithProps({
    isUserTde,
    dealerId,
    deleteFloatingInventory,
    exonerationsList,
    putFloatingInventory,
    currentFlUserGroup,
    filters,
  });


  const data = useMemo(() => dataTable, [updateTable]);
  const columns = useMemo(() => columnsTable, [updateTable]);
  const useTableProps = {
    columns,
    data,
    'defaultColumn': {'Filter': FloatingInventoryFilter},
    'initialState': {
      'pageIndex': 0,
      'pageSize': 50,
      'filters': resetFiltersValue,
    },
    'autoResetFilters': false,
  };

  const handleOpenLine = (row, indexCol, i) => {
    const isAvailable = row.floatingVisible === 'S';

    if (
      (isUserTde && indexCol === 0) ||
      (indexCol === 26) ||
      (!isUserTde && indexCol === 25) ||
      !isAvailable
    ) {
      return;
    }
    cleanCurrentLineFloating();
    setCurrentLine(formFloatInvData);
    setCurrentLineError(formFloatInvErrors);
    setCurrentFloatingOrderClient(formFloatInvData.document);
    setCurrentFloatingLine({
      'data': {...row, 'index': i},
      isUserTde,
      dealerId,
    });
    setShowModalOrderInfo(true);
  };

  const fixedColumns = isUserTde ? [75, 80, 130, 55, 130, 85, 55, 50] : [80, 130, 55, 130, 85, 55, 50];
  return (
    <>
      <CommercialTable
        columns={columns}
        data={data}
        defaultColumnFilter={FloatingInventoryFilter}
        setFilteredData={setFilteredRowsData}
        fixedColumns={fixedColumns}
        tableWrapperStyles={'container-floating'}
        isSmallCell={true}
        tableType={'fixed'}
        lineColor={['rgb(255, 255, 255)']}
        useTableProps={useTableProps}
        handleClickLine={handleOpenLine}
        resetAllFilters={resetAllFilters}
        setResetAllFilters={setResetAllFilters}
        resetFiltersValue={resetFiltersValue}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  'loading': state.floatingInventory.loading,
  'updateTable': state.floatingInventory.updateTable,
  'isUserTde': state.session.isUserFromTDE,
  'dealerId': state.session.dealerId,
  'exonerationsList': state.exemptionManagment.list,
  'blockTable': state.floatingInventory.blockTable,
  'currentFlUserGroup': state.floatingInventory.currentFlUserGroup,
});

const {
  cleanCurrentLineFloating,
  deleteFloatingInventory,
  putFloatingInventory,
  setBlockFloatingTable,
  setCurrentFloatingLine,
  setCurrentFloatingOrderClient,
} = Actions;

export default connect(mapStateToProps, {
  cleanCurrentLineFloating,
  deleteFloatingInventory,
  putFloatingInventory,
  setBlockFloatingTable,
  setCurrentFloatingLine,
  setCurrentFloatingOrderClient,
})(FloatInventoryTable);
